import { useEffect } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { APIProvider } from "../../utilities/Contexts/DCGAutomationPagesContextProvider";
import { automationPages } from "../../constants/dcgAutomationPageList";
import { useAuth } from "react-oidc-context";
import { markAutomationCompleted } from "../../utilities/getAutomationDataFromLocalStorage";
import useOnboardingNavigation from "../../hooks/useOnboardingNavigation";
import { DcgAutomation } from "../../constants/onboardingVersions";

// This is the entry point for the NEW onboarding flow, DCG Automation
const NewDCGAutomationAccount = () => {
    const auth = useAuth();
    const params = useParams();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    let currentPage = params.formId && Object.keys(automationPages).includes(params.formId) ? params.formId : 'selectRole';
    
    if (automationPages[currentPage].needsAuth) {
        currentPage = auth.isAuthenticated ? currentPage : 'selectRole';
    }
    if (searchParams.get("automationComplete")) {
        markAutomationCompleted(location.pathname);
    }

    const DynamicPageComponent = automationPages[currentPage].page;
    const { setPage } = useOnboardingNavigation(currentPage, automationPages.length, DcgAutomation);

    useEffect(() => {
        setPage(currentPage);
    }, [setPage, currentPage])

    return (
        <div className="container">
            <APIProvider currentPage={automationPages[currentPage]} isDcgAutomation={true}>
                <DynamicPageComponent />
            </APIProvider>
        </div>
    )
}

export default NewDCGAutomationAccount;